import { d as __spreadArray } from '../../tslib.es6-604585c1.js';
import { setObjectToLocalStorage, getObjectFromLocalStorage } from '../browserStorage/index.js';
import { P as ProviderOptions } from '../../constants-3bc57a75.js';

var RECENT_LOGIN_METHODS_KEY = 'recentLoginMethods';
var MAX_RECENT_LOGIN_METHODS = 3;

var addRecentLoginMethod = function addRecentLoginMethod(method) {
  var existingMethods = getRecentLoginMethods();
  var isMethodExists = existingMethods.some(function (m) {
    return m.provider === method.provider && m.email === method.email && m.username === method.username;
  });
  if (!isMethodExists) {
    var filteredMethods = method.provider !== ProviderOptions.email ? existingMethods.filter(function (m) {
      return m.provider !== method.provider;
    }) : existingMethods;
    var methods = __spreadArray([method], filteredMethods, true).slice(0, MAX_RECENT_LOGIN_METHODS);
    setObjectToLocalStorage(RECENT_LOGIN_METHODS_KEY, methods);
  }
};
var getRecentLoginMethods = function getRecentLoginMethods() {
  var methods = getObjectFromLocalStorage(RECENT_LOGIN_METHODS_KEY);
  return methods !== null && methods !== void 0 ? methods : [];
};
var checkIfRecentLoginMethodExists = function checkIfRecentLoginMethodExists() {
  return getRecentLoginMethods().length > 0;
};

export { addRecentLoginMethod, checkIfRecentLoginMethodExists, getRecentLoginMethods };
//# sourceMappingURL=index.js.map
